export default "__VITE_ASSET__D5bf8OkF__"